import { PcbNodeTypes } from "@buildwithflux/models";
import { getInheritedPropValues, mergeInheritedProps } from "../helpers";
export class PcbImpedanceMatcher {
    mergedProps;
    treeManager;
    constructor(treeManager) {
        this.treeManager = treeManager;
        this.mergedProps = {};
    }
    /**
     * NOTE: This is only exposed for testing purposes, do not use outside of tests.
     */
    get impedanceMatchingProps() {
        return this.mergedProps;
    }
    mergeImpedanceMatchingProps(nodeUids, nets, elements) {
        // eslint-disable-next-line @buildwithflux/no-array-foreach
        nodeUids.forEach((nodeUid) => {
            const documentNet = nets[nodeUid];
            if (documentNet) {
                this.mergedProps[nodeUid] = mergeInheritedProps(documentNet, elements);
            }
            else {
                delete this.mergedProps[nodeUid];
            }
        });
    }
    addImpedanceMatchingFieldsForNode(node) {
        if (node && node.type === PcbNodeTypes.net) {
            const netImpedanceProps = this.mergedProps[node.uid];
            if (netImpedanceProps) {
                // Note: this will mutate the impedance matching values on the net node directly
                const rules = getInheritedPropValues(netImpedanceProps, Object.values(this.mergedProps));
                return this.treeManager.updatePcbLayoutNode(node.uid, (nodeDataDraft) => {
                    if (nodeDataDraft.type === PcbNodeTypes.net) {
                        nodeDataDraft.impedance = rules.impedance;
                        nodeDataDraft.impedancePair = rules.impedancePair;
                        nodeDataDraft.current = rules.current;
                        nodeDataDraft.desiredTemperatureRise = rules.desiredTemperatureRise;
                    }
                });
            }
        }
        return node;
    }
}
//# sourceMappingURL=PcbImpedanceMatcher.js.map